import { render, staticRenderFns } from "./FilterPresets.vue?vue&type=template&id=163f5cc0&scoped=true&"
import script from "./FilterPresets.vue?vue&type=script&lang=js&"
export * from "./FilterPresets.vue?vue&type=script&lang=js&"
import style0 from "./FilterPresets.vue?vue&type=style&index=0&id=163f5cc0&scoped=true&lang=css&"
import style1 from "./FilterPresets.vue?vue&type=style&index=1&id=163f5cc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163f5cc0",
  null
  
)

export default component.exports